import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {User} from '../User';
import {Affiliate, ApiService, SoftwaresList} from '../api/api.service';

@Injectable()
export class PartnerUsersResolver implements Resolve<Observable<Affiliate[]>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getPartnerUsers();
  }
}
